module.exports = __webpack_public_path__ + "img/bracket-3.6fe8b6a0.svg";